import React, { useContext } from "react";

import { AttributesContext, AttributeGroupDataContext } from "../../../../contexts/attributes";

const SaveGroup = ({ attributeList, uuid, parentAttribute, selectedId, setSelectedId }) => {
    const attributes = useContext(AttributesContext);
    const attributeGroup = useContext(AttributeGroupDataContext);

    const saveGroup = () => {
        const groupValues = attributeList.reduce((obj, a) => {
            obj[a.uuid] = attributeGroup.data[a.uuid] || "";

            return obj;
        }, {});
        const resetValues = attributeList.reduce((obj, a) => {
            obj[a.uuid] = "";

            return obj;
        }, {});
        const currentValue = attributeGroup.data[uuid] || [];
        const parentValue = parentAttribute.uuid
            ? {
                  ...attributes.data[parentAttribute.uuid],
                  [uuid]: [...currentValue, groupValues],
              }
            : {};

        if (selectedId) {
            const originalAddress = currentValue.find((current) => current.id === selectedId);
            const updatedAddress = attributeList.reduce((obj, a) => {
                const isEmpty = attributeGroup.data[a.uuid] !== null && attributeGroup.data[a.uuid] === "" ? "" : originalAddress[a.uuid];
                obj[a.uuid] = attributeGroup.data[a.uuid] || isEmpty;

                return obj;
            }, {});
            const updatedList = currentValue.map((current) => {
                if (current.id === selectedId) {
                    return updatedAddress;
                }

                return current;
            });
            const newParent = {
                ...attributes.data[parentAttribute.uuid],
                [uuid]: updatedList,
            };

            attributes.update(parentAttribute, {
                ...newParent,
            });

            return setSelectedId(null);
        }

        if (parentAttribute) {
            attributes.update(parentAttribute, {
                ...parentValue,
            });
        }

        attributeGroup.updateMany({
            ...resetValues,
            ...parentValue,
            [uuid]: [groupValues],
        });
    };

    return (
        <button
            key={`button_`}
            className="button -primary"
            onClick={saveGroup}
        >
            {selectedId ? "Update" : "Add"}
        </button>
    );
};

export default SaveGroup;
